import { dashboardIcon } from "../../assets/img";

export const ServiceBasedBookings = () => {
  const styles = {
    label: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "14px", // smaller
      lineHeight: "20px",
      color: "#A7A7A7",
    },
    value: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "16px", // smaller
      lineHeight: "22px",
      color: "#222227",
    },
  };

  return (
    <div
      style={{
        padding: 14, // smaller
        width: "100%",
        background: "#FFFFFF",
        boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)", // lighter
        borderRadius: "8px", // smaller
        paddingBottom: 10,
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12, // smaller
        }}
      >
        <p
          style={{
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "15px", // smaller
            lineHeight: "20px",
            display: "flex",
            alignItems: "center",
            color: "#222227",
            margin: 0,
          }}
        >
          Service Based Bookings
        </p>
      </div>

      {/* Total Bookings */}
      <div
        style={{
          border: "1px solid #EEEEEE",
          display: "flex",
          justifyContent: "space-between",
          borderRadius: "16px", // smaller
          padding: "14px 20px", // smaller
          marginTop: "14px", // smaller
        }}
      >
        <div>
          <p
            style={{
              fontSize: "16px", // smaller
              fontWeight: "400",
              color: "#9ca3af",
              margin: 0,
            }}
          >
            Total Bookings
          </p>
          <p
            style={{
              fontSize: "22px", // smaller
              fontWeight: "bold",
              color: "#000000",
              margin: 0,
            }}
          >
            10,000
          </p>
        </div>
        <div style={{ width: "26px", height: "26px" }}>
          <img
            src={dashboardIcon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      {/* Total Section */}
      <p
        style={{
          marginTop: "8px",
          fontFamily: "Open Sans",
          fontStyle: "normal",
          fontWeight: "700",
          fontSize: "15px", // smaller
          lineHeight: "20px",
          color: "#222227",
        }}
      >
        Total
      </p>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 4,
          justifyContent: "space-between",
          marginTop: "8px",
        }}
      >
        {[
          { label: "Room Bookings", value: 1000 },
          { label: "Get Together", value: 1000 },
          { label: "Day Outing", value: 1000 },
          { label: "Just Walk-In", value: 1000 },
          { label: "Room Sharing", value: 1000 },
          { label: "Cancelled Booking", value: 1000 },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              background: "#F5F5F5",
              display: "flex",
              justifyContent: "space-between",
              padding: "8px 10px", // smaller
              width: "48%",
              borderRadius: "8px", // smaller
              marginBottom: "8px", // smaller
            }}
          >
            <p style={styles.label}>{item.label}</p>
            <p style={styles.value}>{item.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
